import { render } from "./SupportPage.vue?vue&type=template&id=2c1e7dda"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__